import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { FormFieldWrapper } from "../../core/shared/FormFieldWrapper";
import { Grid } from "../Grid";
import { Typography } from "../Typography";
import CheckboxSkeleton from "./CheckboxSkeleton";
import { LabelField } from "./styles";
import CheckboxRoot from "./CheckboxRoot";
export function Checkbox({ options, onChange, initialValue, direction = "row", innerGap = "8", outerGap = "8", name, feedback, label: inputLabel, required = false, disabled = false, loading, typographyProps, autoCapitalize = true, size = "normal", }) {
    const [values, setValues] = useState(initialValue || []);
    const handleChange = (checked, id) => {
        setValues((prevState) => checked
            ? [...prevState, id]
            : [...prevState.filter((item) => item !== id)]);
    };
    useEffect(() => {
        onChange(values, name);
        // eslint-disable-next-line
    }, [values]);
    useEffect(() => {
        if (!initialValue?.length) {
            setValues([]);
        }
    }, [initialValue]);
    return (_jsx(FormFieldWrapper, { label: inputLabel, required: required, disabled: disabled, name: name, onChangeFeedback: () => { }, value: [], feedback: loading ? undefined : feedback, width: "100%", children: loading ? (_jsx(CheckboxSkeleton, { outerGap: outerGap, direction: direction, options: options, innerGap: innerGap })) : (_jsx(Grid, { gap: `${outerGap}px`, columns: direction === "column"
                ? `repeat(${options.length}, 1fr)`
                : undefined, children: options.map(({ label, value }) => {
                const isChecked = Boolean(values?.includes(value));
                return (_jsx(Grid, { gap: `${innerGap}px`, children: _jsxs(LabelField, { disabled: disabled, htmlFor: value, children: [_jsx("input", { id: value, "data-testid": `checkbox-${value}`, type: "checkbox", onChange: ({ currentTarget: { id, checked } }) => handleChange(checked, id), checked: isChecked }), _jsx(CheckboxRoot, { id: value, disabled: disabled, isChecked: isChecked, size: size }), _jsx(Typography, { variant: "ParagraphSmall/Regular", color: "--text-primary", title: typeof label === "string" ? label : undefined, textEllipsis: 1, ...typographyProps, children: typeof label === "string"
                                    ? label[autoCapitalize ? "capitalize" : "toString"]()
                                    : label })] }) }, value));
            }) })) }));
}
//# sourceMappingURL=index.js.map